import { AppStore } from '../../headless';

export const trans = (text: string) => {
    const data = AppStore.getInstance().get();
    return data.texts?.data.find((item) => item.attributes?.key === text)?.attributes?.value ?? '';
};
